import React, { useState } from 'react';
import MoreItemsArrow from '../buttons/MoreItemsArrow';

export const DisplayLimit = ({ display = 0, inc = 0, max = 0, moreItemsText, render, style }) => {
  const [count, setCount] = useState(display);
  const increment = () => setCount(count => Math.min(count + inc, max));

  return (
    <div style={style}>
      {render({ count })}
      {count < max && <MoreItemsArrow onClick={increment} text={moreItemsText} />}
    </div>
  );
};
